export default __webpack_public_path__ + "static/media/unhcr-logo-white.0203ec8a.png";